import React, { useEffect, useState }  from "react"
import {HashRouter,Switch,Route} from "react-router-dom"
import 'bulma/css/bulma.css'
import View from 'componentes/indicators/view'
import Home from 'componentes/indicators/home'
import HomeReports from 'componentes/indicators/homeReports'
import ViewReports from 'componentes/indicators/viewReports'
import IndicatorsList from 'componentes/indicators/index'
import ThematicsList from 'componentes/indicators/thematics'
import ThematicsForm from 'componentes/indicators/formThematics'
import SubthematicsList from 'componentes/indicators/subthematics'
import SubthematicsForm from 'componentes/indicators/formSubthematics'
import CategoriesList from 'componentes/indicators/categories'
import CategoriesForm from 'componentes/indicators/formCategories'
import SubcategoriesList from 'componentes/indicators/subcategories'
import SubcategoriesForm from 'componentes/indicators/formSubcategories'
import IndicatorsForm from 'componentes/indicators/formIndicators'
import CountriesList from 'componentes/indicators/countries'
import CountriesForm from 'componentes/indicators/formCountries'
import UnitsList from 'componentes/indicators/units'
import UnitsForm from 'componentes/indicators/formUnits'
import SourcesList from 'componentes/indicators/sources'
import SourcesForm from 'componentes/indicators/formSources'
import ImportFiles from 'componentes/indicators/importFiles'
import store from 'redux/reducers'
import { Provider } from 'react-redux'
import IndicatorValuesList from 'componentes/indicators/indicatorValues'
import IndicatorValuesForm from 'componentes/indicators/formIndicatorValues'
import LanguageHelper from "helpers/language_helper";
import TranslationsForm from 'componentes/indicators/formTranslations';

export default function App() {
  const [leng, setLeng] = useState(null);
  //sessionStorage.setItem('languageId', 'ES');

  useEffect(() => {
     setLeng(LanguageHelper.getLanguageFile());
  }, [leng]);

    return (
        <>
        <Provider store={ store }>
            <HashRouter >
            <Switch>
                    <Route exact path="/" component={Home}  /> {/*exact path="/indicators" component={Home} */}
                    <Route exact path="/viewIndicators/:dsh/:id" component={View} />
                    <Route exact path="/reports" component={HomeReports} /> {/*exact path="/reports" */}
                    <Route exact path="/viewReports" component={ViewReports} />
                    

                    <Route> {/*path="/intranetIndicators" */}
                    
                      <Switch>
                      <Route exact path="/intranetIndicators/indicatorsList" component={IndicatorsList} />
                      <Route exact path="/intranetIndicators/thematicsList" component={ThematicsList} />
                      <Route exact path="/intranetIndicators/thematicsList/:id" component={ThematicsForm} />
                      <Route exact path="/intranetIndicators/subthematicsList" component={SubthematicsList} />
                      <Route exact path="/intranetIndicators/subthematicsList/:id" component={SubthematicsForm} />
                      <Route exact path="/intranetIndicators/categoriesList" component={CategoriesList} />
                      <Route exact path="/intranetIndicators/categoriesList/:id" component={CategoriesForm} />
                      <Route exact path="/intranetIndicators/subcategoriesList" component={SubcategoriesList} />
                      <Route exact path="/intranetIndicators/subcategoriesList/:id" component={SubcategoriesForm} />
                      <Route exact path="/intranetIndicators/indicatorsList/:id" component={IndicatorsForm} />
                      <Route exact path="/intranetIndicators/countriesList" component={CountriesList} />
                      <Route exact path="/intranetIndicators/countriesList/:id" component={CountriesForm} />
                      <Route exact path="/intranetIndicators/unitsList" component={UnitsList} />
                      <Route exact path="/intranetIndicators/unitsList/:id" component={UnitsForm} />
                      <Route exact path="/intranetIndicators/sourcesList" component={SourcesList} />
                      <Route exact path="/intranetIndicators/sourcesList/:id" component={SourcesForm} />
                      <Route exact path="/intranetIndicators/importFile" component={ImportFiles} />
                      <Route exact path="/intranetIndicators/indicatorValuesList" component={IndicatorValuesList} />
                      <Route exact path="/intranetIndicators/indicatorValuesList/:id" component={IndicatorValuesForm} />
                      <Route exact path="/intranetIndicators/translationsList/:idT" component={TranslationsForm} />
                      </Switch>
                    </Route>
            </Switch>   
            </HashRouter>
          </Provider> 
        </>
  );
}

